module.exports = __webpack_public_path__ + "img/people.7a86b8ea.svg";